import React from "react";
import useTestQuestion from "./useTestQuestion";
import TestQuestion from "./Components/TestQuestion";

const TestQuestionIndex: React.FC = () => {
  const testQuestionProps = useTestQuestion();

  return <TestQuestion />;
};
export default TestQuestionIndex;
